export enum AffiliateAccessStatus {
  Closed,
  Opened,
}
